import { useState } from 'react';

import { budgetMemberService } from '@/services/budget-member.service';

interface UseInviteBudgetMembersOptions {
  onSuccess?: () => void;
  refreshMembers?: () => Promise<void>;
}

export const useInviteBudgetMembers = (budgetId?: string, options?: UseInviteBudgetMembersOptions) => {
  const [isInviteModalOpen, setIsInviteModalOpen] = useState(false);
  const [isInviting, setIsInviting] = useState(false);

  const handleInviteMembers = async (emails: string[]) => {
    if (!budgetId) {
      throw new Error('Budget ID is missing');
    }

    try {
      setIsInviting(true);

      const membersResponse = await budgetMemberService.getMembers(budgetId);
      const pendingEmails = (membersResponse.data ?? []).map((member) => member.email);

      for (const email of emails) {
        await budgetMemberService.validateMemberEmail({
          email,
          budget_id: budgetId,
          pending_emails: pendingEmails
        });

        await budgetMemberService.inviteMember({
          budgetId,
          email,
          role: 'STAFF'
        });

        pendingEmails.push(email);
      }

      setIsInviteModalOpen(false);
      await options?.refreshMembers?.();
      options?.onSuccess?.();
    } catch (error: any) {
      console.error('Error inviting members:', error);
      throw error instanceof Error
        ? error
        : new Error(error?.message ?? 'Failed to send invitations. Please try again.');
    } finally {
      setIsInviting(false);
    }
  };

  return {
    isInviteModalOpen,
    setIsInviteModalOpen,
    isInviting,
    handleInviteMembers
  };
};
